import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from "@angular/core";
import {generateGrungeMask} from '../../utils/image-utils';

@Component({
    selector: "woa-icon",
    templateUrl: "./icon.component.html",
    styleUrl: "./icon.component.scss",
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
    public readonly name: InputSignal<string> = input.required<string>();

    public readonly grungeSeed: InputSignal<string> = input<string>(undefined);

    public readonly grungeMaskUrl: Signal<string> = computed<string>(() =>
        this.grungeSeed() ? `url(${generateGrungeMask(this.grungeSeed())})` : undefined);
}
